import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import Icon from '../Icon';

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix' | 'suffix'> & {
    label?: string;
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
};

export default function TextField({ label, type = 'text', className, prefix, suffix, ...props }: Props) {
    const [show, setShow] = useState(false);
    const isPassword = type === 'password';
    const hasPrefix = Boolean(prefix);
    const hasSuffix = Boolean(suffix) || isPassword;

    return (
        <label className="block">
            {label && (
                <span className="mb-1 block text-sm font-semibold text-gray-700 dark:text-gray-200">{label}</span>
            )}
            <div className="relative">
                <input
                    {...props}
                    type={isPassword ? (show ? 'text' : 'password') : type}
                    className={[
                        'w-full rounded-xl border py-3 text-sm outline-none transition',
                        'bg-white text-gray-900 placeholder:text-gray-400 border-gray-300 shadow-sm focus:border-blue-500',
                        'dark:bg-black/30 dark:text-gray-100 dark:border-gray-600 dark:shadow-none',
                        hasPrefix ? 'pl-12' : 'pl-4',
                        hasSuffix ? 'pr-12' : 'pr-4',
                        className || ''
                    ].join(' ')}
                />
                {hasPrefix && (
                    <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-300 w-5 h-5 flex items-center justify-center">
                        {prefix}
                    </span>
                )}
                {isPassword && (
                    <button
                        type="button"
                        aria-label={show ? 'Hide password' : 'Show password'}
                        onClick={() => setShow((s) => !s)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
                    >
                        {show ? <Icon icon={FiEyeOff} /> : <Icon icon={FiEye} />}
                    </button>
                )}
                {!isPassword && suffix && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-300 w-5 h-5 flex items-center justify-center">
                        {suffix}
                    </div>
                )}
            </div>
        </label>
    );
}
